import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { connect, useSelector } from 'react-redux'
import CryptoJs from 'crypto-js';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Divider from '@material-ui/core/Divider';
import Table from 'react-bootstrap/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import { useHistory } from 'react-router-dom';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import HttpService from '../services/httpService';
import RadioGroup from '@material-ui/core/RadioGroup';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { TextField, FormControl, Typography, DialogTitle, Card, CardContent } from '@material-ui/core';
import moment from 'moment'
import { commaSeparateAmount } from './commaSeparate';
import WonForm from '../pages/customerSurveyForm/won';
import { ROLENAME, constantDepartmentId, finalizationOfMaterialStages, designFinalizationOfMaterialStages, designDepartment } from '../utils/index';
import { textAlign } from '@mui/system';
import '../App.css';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { dateTimePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';
import { Box } from '@material-ui/core';




const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    container: {
        maxHeight: 450,
    },
}));
const MaterialsCheckList = (props) => {
    const routerHistory = useHistory();
    const [loading, setLoading] = React.useState(false);
    const { userDetails } = useSelector(state => state.user)
    const inputChecklistFeids = useRef();
    const classes = useStyles();
    const ref = useRef(null);
    const { leadId } = useParams();
    const [checkList, setCheckList] = useState([]);
    useEffect(() => {
        getCheckListData();
        getLeadDetails();
    }, [leadId])


    const [leadDetail, setLeadDetails] = useState([]);
    const [checkListRemarkByCustomer, setCheckListRemarkByCustomer] = useState('');


    const [formData, setFormData] = useState({
        clientRemarks: '',

    });
    const [isClientSubmitted, setIsClientSubmitted] = useState(false);
    const [isDesignSubmitted, setIsDesignSubmitted] = useState(false);
    const [openDialogForADMRejection, setOpenDialogForADMRejection] = useState(false)
    const [openDialogForClientRejection, setOpenDialogForClientRejection] = useState(false)

    const [admRejectionRemarks, setADMRejectionRemarks] = useState('');
    const [clientRejectionRemarks, setClientRejectionRemarks] = useState('');


    const getLeadDetails = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getLeadDetails(leadId);
            setTimeout(() => {
                setLeadDetails(response.data)
            })
            if (finalizationOfMaterialStages.includes(response?.data?.finalizationOfMaterialStageStatus)) {
                setIsClientSubmitted(true)
            }
            if (designFinalizationOfMaterialStages.includes(response?.data?.finalizationOfMaterialStageStatus)) {
                setIsDesignSubmitted(true)
            }

        } catch (error) {
            console.log('getLeadDetails error', error)
            props.setSnackInfo(error?.response?.data ?? " getLeadDetails Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getCheckListData = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getElectricChecklistData(leadId);

            setTimeout(() => {
                setFormData(response?.data?.formData || {});
                setCheckListRemarkByCustomer(response?.data?.remark)
            })
        } catch (error) {
            console.log("error getCheckListData", error)
            props.setSnackInfo(error?.response?.data ?? "getCheckListData Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const handleCheckboxChange = (itemId, option) => {
        setFormData((prev) => {
            const newSelected = prev[itemId]?.selectedOptions === option ? null : option;
            const updatedFormData = { ...prev };

            if (newSelected === null) {
                delete updatedFormData[itemId];
            } else {
                updatedFormData[itemId] = {
                    selectedOptions: newSelected,
                    designerDimensions: prev[itemId]?.designerDimensions || "",
                };
            }
            return updatedFormData;
        });
    };

    const navigateToApprovalsPage = (e, data) => {
        routerHistory.push(`/materials-checklist-approvals`);
    };


    const navigateToLeadPage = (leadId) => {
        routerHistory.push(`/project-logs/${leadId}`);
    };


    const handleInputChange = (itemId, field, value) => {
        setFormData((prev) => {
            const newState = { ...prev };
            if (value.trim() === '') {
                if (newState[itemId]) {
                    delete newState[itemId][field];
                    if (Object.keys(newState[itemId]).length === 0) {
                        delete newState[itemId];
                    }
                }
            } else {
                newState[itemId] = {
                    ...newState[itemId],
                    [field]: value,
                };
            }
            return newState;
        });
    };


    const handleSubmit = async () => {

        let isValid = true;

        const invalidItems = Object.entries(formData).filter(([key, item]) => {
            if (!item || typeof item !== 'object') return false;

            return (
                !item.selectedOptions ||
                !item.clientDimensions ||
                item.clientDimensions.trim() === ""
            );
        });



        if (invalidItems.length > 0) {
            isValid = false;
            props.setSnackInfo(" Client Appliances Dimensions field cannot be empty if checkbox is selected ", "error");
        }

        if (isValid) {
            try {

                const obj = {
                    leadId: leadId,
                    submittedBy: "Client",
                    formData: formData,
                    checkListRemarkByCustomer: checkListRemarkByCustomer
                    }


                const response = await HttpService.matChecklistSubmitted(obj)
                const result = await response.data

                if (response.status === 200) {
                    props.setSnackInfo("Checklist submitted successfully!", "success");

                    // Disable input fields after submission
                    setFormData((prev) => {
                        const updatedData = {};
                        Object.entries(prev).forEach(([itemId, data]) => {
                            updatedData[itemId] = { ...data };
                        });
                        getLeadDetails();
                        return updatedData;
                    });

                } else {
                    throw new Error(result.message || "Error submitting checklist");
                }
            } catch (error) {
                props.setSnackInfo(error.message, "error");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleDesignSubmit = async () => {

        let isValid = true;

        const invalidItems = Object.entries(formData).filter(([key, item]) => {
            if (!item || typeof item !== 'object') return false;

            return (
                !item.selectedOptions ||
                !item.clientDimensions ||
                !item.designerDimensions ||
                item.clientDimensions.trim() === "" ||
                item.designerDimensions.trim() === ""

            );
        });

        if (invalidItems.length > 0) {
            isValid = false;
            props.setSnackInfo("Designer Dimensions cannot be empty for selected items", "error");
        }

        if (isValid) {
            try {
                setLoading(true);
                let obj = {}
                obj.leadId = leadId
                obj.submittedBy = "Design"
                obj.formData = formData
                obj.User = userDetails.name

                const response = await HttpService.matChecklistSubmitted(obj)

                const result = await response.data

                if (response.status === 200) {
                    props.setSnackInfo("Checklist submitted successfully!", "success");

                    setFormData((prev) => {
                        const updatedData = {};
                        Object.entries(prev).forEach(([itemId, data]) => {
                            updatedData[itemId] = { ...data };
                        });
                        getLeadDetails();
                        navigateToLeadPage(leadId);
                        return updatedData;
                    });
                } 
                else {
                    throw new Error(result.message || "Error submitting checklist");
                }
            } catch (error) {
                props.setSnackInfo(error.message, "error");
            } finally {
                setLoading(false);
            }
        }
    };

    const hadndleADMApproval = async () => {
        try {
            setLoading(true);

            const obj = {
                leadId: leadId,
                submittedBy: "ADM Approval",
                User: userDetails.name
                }

            const response = await HttpService.matChecklistSubmitted(obj)
            setLoading(false);
            if (response.status === 200) {
                props.setSnackInfo("Sent for client approval", "success");
                getLeadDetails();
                navigateToApprovalsPage();
            }


        } catch (error) {
            props.setSnackInfo(error.message, "error");
        }
    }


    const hadndleADMRejection = async (admRejectionRemarks) => {
        try {
            setLoading(true);

            const obj = {
                leadId: leadId,
                submittedBy: "ADM Rejection",
                User: userDetails.name,
                admRejectionRemarks: admRejectionRemarks
                }

            const response = await HttpService.matChecklistSubmitted(obj)
            setLoading(false);
            if (response.status === 200) {
                props.setSnackInfo("Rejected Successfully", "success");
                setOpenDialogForADMRejection(false)
                getLeadDetails();
                navigateToApprovalsPage();
            }

        } catch (error) {
            props.setSnackInfo(error.message, "error");
        }
    }

    const handleClientApproval = async () => {
        try {
            props.setLoading(true)

            const obj = {
                leadId: leadId,
                submittedBy: "Client Approval",
                User: userDetails.name,
                admRejectionRemarks: admRejectionRemarks,
                formData: {
                    ...formData,
                    erpProjectNo: leadDetail?.erpProjectNo,
                    clientName: leadDetail?.customerId?.name,
                    designerUserName: leadDetail?.assignTo?.name
                }
            };

            

            const response = await HttpService.matChecklistSubmitted(obj)
            props.setLoading(false)
            if (response.status === 200) {
                props.setSnackInfo("Aprproved", "success");
                getLeadDetails();
            }


        } catch (error) {
            props.setSnackInfo(error.message, "error");
        }
    }

    const handleClientRejection = async (clientRejectionRemarks) => {
        try {

            

            const obj = {
                leadId: leadId,
                submittedBy: "Client Rejection",
                clientRejectionRemarks: clientRejectionRemarks,
            };
            setLoading(true);
            const response = await HttpService.matChecklistSubmitted(obj)
            setLoading(false);
            if (response.status === 200) {
                props.setSnackInfo("Rejected Successfully", "success");
                setOpenDialogForClientRejection(false)
                getLeadDetails();
            }

        } catch (error) {
            props.setSnackInfo(error.message, "error");
        }
    }

    const handleRemarkChange = (e) => {
        const value = e.target.value;
        setCheckListRemarkByCustomer(value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            clientRemarks: value,
        }));
    };


    const handleADMReject = (event, data) => {
        {
            setOpenDialogForADMRejection(true)
        }
    }

    const handleClientReject = (event, data) => {
        {
            setOpenDialogForClientRejection(true)
        }
    }


    const electroChecklistItems = [
        { id: 1, name: "HOB", options: ["Built In", "Counter Top"] },
        { id: 2, name: "Chimney", options: ["Ceiling Mounted", "Wall Mounted"] },
        { id: 3, name: "RO", options: ["Wall Mounted", "Under Sink"] },
        { id: 4, name: "Microwave Oven", options: ["Built In", "Standalone"] },
        { id: 5, name: "OTG", options: ["Built In", "Standalone"] },
        { id: 6, name: "Sink", options: ["Single Bowl(SB)", "Double Bowl(DB)", "SB With Drain Right", "SB With Drain Left", "DB With Drain Right", "DB With Drain Left"] },
        { id: 7, name: "Tap For Sink", options: ["Wall Mounted", "Counter Top"] },
        { id: 8, name: "Dishwasher", options: ["Built In", "Standalone"] },
        { id: 9, name: "Refrigerator", options: ["Built In", "Standalone"] },
        { id: 10, name: "Washing Machine(WM)", options: ["Top Load", "Front Load"] },
        { id: 11, name: "Copper Gas Piping", options: ["Gail/Existing Reuse", "New Connection"] },
        { id: 12, name: "Core Cutting", options: ["Existing Reuse", "New Core Cutting"] },
        { id: 13, name: "Television", options: ["isRequired"] },
    ];


    return (
        <div>
            <div style={{ marginBottom: 20, marginTop: 50 }}>
                <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}><strong>ELECTRICAL-DOMESTIC CHECKLIST</strong></Typography>
            </div>
            <div style={{ margin: 'auto', width: '90%' }}>
                <Paper>
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <hr />
                            <div className='responsiveUserInfo'>
                                <Table striped bordered hover style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ border: '0.5px solid lightgray', fontWeight: "500" }}> Customer Name</td>
                                            <td style={{ border: '0.5px solid lightgray', fontWeight: "450" }}>{leadDetail?.customerId?.name}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: '0.5px solid lightgray', fontWeight: "500" }}>Project No: </td>
                                            <td style={{ border: '0.5px solid lightgray', fontWeight: "450" }}>{leadDetail?.erpProjectNo || 'NA'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: '0.5px solid lightgray', fontWeight: "500" }}>Designer Name </td>
                                            <td style={{ border: '0.5px solid lightgray', fontWeight: "450" }}>{leadDetail?.assignTo?.name || 'NA'}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </CardContent>
                    </Card>
                </Paper>
                <br />

                <br />
                <Paper style={{ margin: "20px 0", padding: "20px" }}>
                    <Card variant="outlined">
                        <CardContent>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Sl. No.</th>
                                        <th>Appliance (Or) Domestic Items</th>
                                        <th>Type</th>
                                        <th style={{ textAlign: "center" }}>
                                            To Be Filled By Client
                                            <br /> Appliances Dimensions
                                            <br /> L * W * H
                                        </th>
                                        <th style={{ textAlign: "center" }}>
                                            To Be Filled By Designer
                                            <br /> Cabinet Dimensions
                                            <br /> L * W * H
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {electroChecklistItems.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>
                                                {item.options.length > 0 ? (
                                                    item.options.map((option, optIndex) => (
                                                        <label key={optIndex} style={{ marginRight: "10px" }}>
                                                            <input
                                                                type="checkbox"
                                                                name={`type-${item.id}`}
                                                                value={formData[item.id]?.selectedOptions}
                                                                checked={formData[item.id]?.selectedOptions === option}
                                                                onChange={() => handleCheckboxChange(item.id, option)}
                                                                disabled={isClientSubmitted}
                                                            />
                                                            {option}
                                                        </label>

                                                    ))
                                                ) : (
                                                    "N/A"
                                                )}
                                            </td>
                                            <td>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Enter dimensions"
                                                    fullWidth
                                                    value={formData[item.id]?.clientDimensions || ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const regex = /^[0-9*]*$/;
                                                        if (!regex.test(value)) {
                                                            // If the value contains any characters other than numbers and "*", show an error
                                                            props.setSnackInfo("Only numbers and '*' are allowed", "error");
                                                            return; // Prevent updating the state with invalid input
                                                        }
                                                        handleInputChange(item.id, "clientDimensions", value);
                                                    }}
                                                    disabled={isClientSubmitted || !formData[item.id]?.selectedOptions?.length}
                                                    inputProps={{ pattern: "[0-9*]*" }} // Optional: hints for browsers supporting pattern attribute
                                                />
                                            </td>
                                            <td>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Enter dimensions"
                                                    fullWidth
                                                    value={formData[item.id]?.designerDimensions}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const regex = /^[0-9*]*$/;
                                                        if (!regex.test(value)) {
                                                            props.setSnackInfo("Only numbers and '*' are allowed", "error");
                                                            return; // Prevent updating the state with invalid input
                                                        }
                                                        handleInputChange(item.id, "designerDimensions", value)
                                                    }}
                                                    disabled={isDesignSubmitted || !formData[item.id]?.selectedOptions?.length || userDetails.departmentId !== designDepartment}
                                                    inputProps={{ pattern: "[0-9*]*" }}
                                                />

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </CardContent>
                    </Card>
                </Paper>

                <br />
                <br />
                <Paper>
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Typography variant="h5" component="h2">Remarks (Note: Please specify the details of any other appliances not included in the above list)</Typography>
                            <hr />
                            <FormControl style={{ width: 300, paddingTop: 10 }}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    label="Enter your remark"
                                    multiline
                                    maxRows={4}
                                    value={formData.clientRemarks}
                                    name="checkListRemarkByCustomer"
                                    onChange={handleRemarkChange}
                                    variant="outlined"
                                    disabled={isClientSubmitted}
                                />
                            </FormControl>
                        </CardContent>
                    </Card>
                </Paper>
                <br />

                <br />
            </div>
            {(leadDetail.finalizationOfMaterialStageStatus === "Not Initiated") && (
                <button
                    onClick={handleSubmit}
                    style={{ display: "block", margin: "20px auto", padding: "10px 20px", fontSize: "16px" }}
                >
                    Submit
                </button>
            )
            }

            {(userDetails.departmentId === designDepartment && leadDetail.finalizationOfMaterialStageStatus === "Client Submitted") && (
                <button
                    onClick={handleDesignSubmit}
                    style={{ display: "block", margin: "20px auto", padding: "10px 20px", fontSize: "16px" }}
                >
                    Submit and Send for Approval
                </button>
            )
            }

            <Paper style={{ padding: 10 }}>
                <div
                    style={{
                        marginTop: '20px',
                        marginBottom: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '20px'
                    }}
                >
                    {(userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager)) && leadDetail.finalizationOfMaterialStageStatus === "Sent for ADM approval" && (
                        <Button
                            onClick={hadndleADMApproval}
                            variant="outlined"
                            color="primary"
                        >
                            Send for Client Approval
                        </Button>
                    )
                    }
                    {(userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager)) && leadDetail.finalizationOfMaterialStageStatus === "Sent for ADM approval" && (
                        <Button
                            onClick={handleADMReject}
                            variant="outlined"                            >
                            Reject
                        </Button>
                    )
                    }
                </div>
            </Paper>




            <Paper style={{ padding: 10 }}>
                <div
                    style={{
                        marginTop: '20px',
                        marginBottom: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '20px'
                    }}
                >
                    {(leadDetail.finalizationOfMaterialStageStatus === "Sent for client approval" && (userDetails && Object.keys(userDetails).length === 0)) && (
                        <Button
                            onClick={handleClientApproval}
                            variant="contained"
                            color="primary"
                        >
                            Approve
                        </Button>
                    )}
                    {(leadDetail.finalizationOfMaterialStageStatus === "Sent for client approval" && (userDetails && Object.keys(userDetails).length === 0)) && (
                        <Button
                            onClick={handleClientReject}
                            variant="outlined"
                        >
                            Reject
                        </Button>
                    )}
                </div>
            </Paper>



            <Dialog open={openDialogForADMRejection} onClose={() => setOpenDialogForADMRejection(false)}>
                <DialogTitle>Reject Remarks </DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 550 }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="custom pagination table">
                                <TableBody>
                                    <TableRow>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* Add Remarks TextField */}
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            label="Remarks"
                            multiline
                            rows={4}
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setADMRejectionRemarks(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => hadndleADMRejection(admRejectionRemarks)} disabled={admRejectionRemarks === ""} variant="contained" color="primary">
                        Proceed
                    </Button>
                    <Button onClick={() => setOpenDialogForADMRejection(false)} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDialogForClientRejection} onClose={() => setOpenDialogForClientRejection(false)}>
                <DialogTitle>Reject Remarks </DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 550 }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="custom pagination table">
                                <TableBody>
                                    <TableRow>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* Add Remarks TextField */}
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            label="Remarks"
                            multiline
                            rows={4}
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setClientRejectionRemarks(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClientRejection(clientRejectionRemarks)} disabled={clientRejectionRemarks === ""} variant="contained" color="primary">
                        Proceed
                    </Button>
                    <Button onClick={() => setOpenDialogForClientRejection(false)} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </div>

    )
}

export default connect(null, { setLoading, setSnackInfo })(MaterialsCheckList)